import { Button, Group, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useEffect } from 'react';

import { TransitGuarantee } from '@e-origin/shared';

import { TextInput } from '@components';
import { useDeclarant } from '@hooks/declarant';

interface EditTransitGuaranteeAccessCodeDataProps {
  guarantee: TransitGuarantee;

  onSave: (values: TransitGuarantee) => void;
  onClose: () => void;
}

export const EditTransitGuaranteeAccessCodeData: React.FC<EditTransitGuaranteeAccessCodeDataProps> = ({ guarantee, onSave, onClose }) => {
  const { data: declarant } = useDeclarant();

  const form = useForm<TransitGuarantee>({
    initialValues: guarantee,
  });

  useEffect(() => {
    if (!form.values.holderId) {
      const prefill = declarant?.customsAuthentication?.enterpriseNumber || '';
      if (prefill) {
        form.setFieldValue('holderId', prefill);
      }
    }
  }, []);

  return (
    <>
      <Stack>
        <TextInput {...form.getInputProps('holderId')} label="Holder Of The Transit Procedure ID" />
        <TextInput {...form.getInputProps('customsQueryResponse.officeOfGuaranteeReference')} label="Office of guarantee" disabled />
        <TextInput {...form.getInputProps('masterAccessCode')} label="Master Access Code" required />
        <TextInput label="Current access code" value={form.values.reference.accessCode || ''} disabled />
        <TextInput {...form.getInputProps('accessCodeNew')} label="New access code" />
      </Stack>
      <Group justify="flex-end" mt="md">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={() => onSave(form.values)} variant="filled" disabled={!form.values.masterAccessCode}>
          Save
        </Button>
      </Group>
    </>
  );
};
